module.exports = __webpack_public_path__ + "static/img/tool_service_0.175e166e.png";